import type { CustomerTypeAvailabilityType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { CustomerType } from '@/store/types/user'

type Props = {
  customerType: CustomerType
  availableFor?: CustomerTypeAvailabilityType
}

export const isAvailableForCustomerType = ({
  customerType,
  availableFor,
}: Props) => {
  const customerTypeLowerCase = customerType.toLowerCase()

  // Treat Family type as Employee
  const effectiveCustomerType =
    customerTypeLowerCase === 'family' ? 'employee' : customerTypeLowerCase

  if (!availableFor) return false

  return availableFor[
    effectiveCustomerType as keyof CustomerTypeAvailabilityType
  ]
}
